import React, { useState } from "react";
// import Payment from "../Images/Konn3ct Images/payment.png";
import LeafL from "../Images/Konn3ct Images/leaf left.png";
import LeafR from "../Images/Konn3ct Images/right leaf.png";
import { motion } from "framer-motion";
import { Video, Users } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const addons = [
  {
    id: "streaming",
    title: "Streaming Service",
    priceUSD: "$14",
    priceNGN: "₦21,000",
    desc: "High-quality, uninterrupted live streaming for webinars, conferences, and large sessions, with support for simultaneous broadcasts to Facebook, WhatsApp, and other platforms.",
    icon: Video,
    cta: "Addons",
  },
  {
    id: "rooms",
    title: "Room Bundles (10)",
    priceUSD: "$10",
    priceNGN: "₦15,000",
    desc: "Get access to 10 additional meeting rooms for teams, training sessions, and large organizations. Ideal for managing multiple events and classes.",
    icon: Users,
    cta: "Addons",
  },
  {
    id: "whatsapp",
    title: "WhatsApp Invite",
    priceUSD: "$2",
    priceNGN: "₦3,000",
    desc: "Instantly invite participants to meetings via WhatsApp with a single click. Fast, convenient, and perfect for reaching users on the most widely used messaging platform.",
    icon: FaWhatsapp,
    cta: "Addons",
  },
];

const Kpricing = ({ onSelectAddOn } = {}) => {
  const [billing, setBilling] = useState("yearly");
  const [activePlan, setActivePlan] = useState("pro");

  const prices = {
    lite: billing === "yearly" ? "$44" : "$4",
    pro: billing === "yearly" ? "$59" : "$6",
  };

  const handlePlanClick = (plan) => setActivePlan(plan);

  const planClasses = (plan) =>
    `rounded-2xl p-6 flex flex-col transition transform 
     ${
       activePlan === plan
         ? "border-2 border-blue-600 bg-blue-50 shadow-xl scale-[1.02]"
         : "border border-gray-300 hover:border-blue-400 hover:shadow-lg hover:-translate-y-1"
     }`;

  return (
    <div className="relative min-h-screen w-full bg-cover bg-center  text-white font-sans px-4 py-12">
      {/* Navbar */}

      {/* Billing Toggle */}
      <div className="flex justify-center mb-10 mt-10 ">
        <div className="bg-white p-1 rounded-xl flex items-center space-x-2 border border-[#1A4699]">
          <button
            onClick={() => setBilling("yearly")}
            className={`px-5 py-2 rounded-xl text-sm font-medium transition ${
              billing === "yearly"
                ? "bg-[#1A4699] text-white"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            Yearly
          </button>
          <button
            onClick={() => setBilling("monthly")}
            className={`px-5 py-2 rounded-xl text-sm font-medium transition ${
              billing === "monthly"
                ? "bg-[#1A4699] text-white"
                : "text-gray-600 hover:bg-gray-200"
            }`}
          >
            Monthly
          </button>
        </div>
      </div>

      {/* Pricing Container */}
      <div className="max-w-7xl mx-auto border-none rounded-2xl shadow-sm overflow-hidden bg-white">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0 divide-x divide-gray-200">
          {/* Free Plan */}
          <div
            onClick={() => handlePlanClick("free")}
            className={`${planClasses(
              "free"
            )} cursor-pointer border-l-0 sm:border-l`}
          >
            <h2 className="text-lg font-bold text-gray-800">Free forever</h2>
            <p className="text-sm text-gray-500 mb-4">
              Best for individual users
            </p>
            <h3 className="text-3xl font-bold text-green-600 mb-2">Free</h3>
            {/* <span className="text-sm text-green-700 font-medium mb-6">
              Free forever
            </span> */}
            <button
              onClick={() =>
                window.open("https://dashboard.konn3ct.com/register", "_blank")
              }
              className="bg-green-700 text-white py-2 rounded-lg font-semibold mb-6 transition"
            >
              Free forever
            </button>

            <ul className="space-y-2 text-sm text-gray-700 border-t border-dashed pt-4">
              {[
                "Participant - 100",
                "Session Timeout - 1 hour",
                "Number of Rooms - 1",
                "Audio & Video Preview Window",
                "Screen Sharing",
                "Whiteboard & Annotation Tools",
                "User Status",
                "Breakout Rooms",
                "Full-Featured Admin Controls",
                "Share Webcam",
                "Shared Notes",
                "Share YouTube Videos",
                "Attendance",
              ].map((item, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-blue-600 mr-2">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Lite Plan */}
          <div
            onClick={() => handlePlanClick("lite")}
            className={`${planClasses("lite")} cursor-pointer `}
          >
            <h2 className="text-lg font-bold text-gray-800">Lite</h2>
            <p className="text-sm text-gray-500 mb-4">Best for small teams</p>
            <h3 className="text-3xl font-bold mb-2 text-[#1A4699]">
              {prices.lite}
            </h3>
            <p className="text-gray-600 mb-6">
              {billing === "yearly" ?  "₦66,000" : "₦6,000"}
            </p>
            <button
              onClick={() =>
                window.open("https://dashboard.konn3ct.com/register", "_blank")
              }
              className="bg-[#1A4699] hover:bg-blue-700 text-white py-2 rounded-lg font-semibold mb-6 transition"
            >
              Get Started
            </button>

            <ul className="space-y-2 text-sm text-gray-700 border-t border-dashed pt-4">
              {[
                "Participant - 100",
                "Session Timeout - 10 hours",
                "Cloud Storage - 5GB",
                "Number of Rooms - 2",
                "Audio & Video Preview Window",
                "Screen Sharing",
                "Whiteboard & Annotation Tools",
                "User Status",
                "Breakout Rooms",
                "Recording",
                "Full-Featured Admin Controls",
                "Share Webcam",
                "Shared Notes",
                "Share YouTube Videos",
                "Attendance",
              ].map((item, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-blue-600 mr-2">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Pro Plan */}
          <div
            onClick={() => handlePlanClick("pro")}
            className={`${planClasses("pro")} cursor-pointer relative`}
          >
            <h2 className="text-lg font-bold text-gray-800">Pro</h2>
            <p className="text-sm text-gray-500 mb-4">
              Best for mid-sized teams
            </p>
            <span className="absolute top-1 right-3 bg-blue-600 text-white px-3 py-1 text-xs rounded-full">
              Most Popular
            </span>
            <h3 className="text-3xl font-bold mb-2 text-[#1A4699]">
              {prices.pro}
            </h3>
            <p className="text-gray-600 mb-6">
              {billing === "yearly" ? "₦88,000" : "₦8,000"}
            </p>
            <button
              onClick={() =>
                window.open("https://dashboard.konn3ct.com/register", "_blank")
              }
              className="bg-[#1A4699] hover:bg-blue-700 text-white py-2 rounded-lg font-semibold mb-6 transition"
            >
              Start Free Trial
            </button>

            <ul className="space-y-2 text-sm text-gray-700 border-t border-dashed pt-4">
              {[
                " Participant - 250",
                "Session Timeout - 24 hours",
                "Cloud Storage - 15GB",
                "Number of Rooms - 3",
                "Audio & Video Preview Window",
                "Screen Sharing",
                "Whiteboard & Annotation Tools",
                "User Status",
                "Breakout Rooms",
                "Recording",
                "Full-Featured Admin Controls",
                "Share Webcam",
                "Shared Notes",
                "Share YouTube Videos",
                "Attendance",
              ].map((item, i) => (
                <li key={i} className="flex items-start">
                  <span className="text-blue-600 mr-2">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Enterprise Plan */}
          <div
            onClick={() => handlePlanClick("enterprise")}
            className={`${planClasses("enterprise")} cursor-pointer`}
          >
            <h2 className="text-lg font-bold text-gray-800">Enterprise</h2>
            <p className="text-sm text-gray-500 mb-4">
              Best for many large teams
            </p>
            <p className="text-sm text-gray-600 mb-8">
              Get a custom demo and see how Konn3ct aligns with your goals.
            </p>
            <button
              onClick={() =>
                window.open(
                  "https://www.newwavesecosystem.com/contactus",
                  "_blank"
                )
              }
              className="bg-gray-900 hover:bg-gray-800 text-white py-2 rounded-lg font-semibold mb-6 transition"
            >
              Contact Sales
            </button>
          </div>
        </div>
      </div>

      {/* Addons Section */}
      <div className="max-w-7xl mx-auto mt-14 border rounded-2xl p-8 shadow-sm bg-white">
        <h3 className="text-lg font-bold mb-3 text-black">Add-ons</h3>
        <p className="text-sm text-gray-600 mb-4">
          Extras to boost your productivity
        </p>
        {/* <p className="text-sm text-gray-600 mb-4">
          Pick an add‑on to enhance your Konn3ct experience.
        </p> */}

        {/* <ul className="text-sm text-gray-700 space-y-2">
          <li>Streaming Service – $25 / ₦21,000</li>
          <li>Room Bundles (10) – $17 / ₦15,000</li>
          <li>WhatsApp Invite – $5 / ₦3,000</li>
        </ul>

        <button className="bg-[#1A4699] hover:bg-blue-700 text-white py-2 px-4 rounded-lg font-semibold transition mt-4">
              Register
            </button> */}

        <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {addons.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.article
                key={a.id}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08 }}
                className="bg-white hover:bg-blue-50 dark:bg-slate-800 border border-gray-100 dark:border-slate-700 rounded-2xl p-5 shadow-sm hover:shadow-md"
                role="region"
                aria-labelledby={`addon-${a.id}-title`}
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-lg bg-green-700 dark:bg-slate-700">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="flex-1">
                    <h3
                      id={`addon-${a.id}-title`}
                      className="text-lg font-medium text-gray-800 "
                    >
                      {a.title}
                    </h3>
                    <p className="text-sm text-muted-foreground mt-1 text-gray-500">
                      {a.desc}
                    </p>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-semibold text-[#1A4699]">
                      {a.priceUSD}
                    </div>
                    <div className="text-sm text-muted-foreground text-gray-800">
                      {a.priceNGN}
                    </div>
                  </div>
                </div>

                <div className="mt-4 flex items-center justify-between gap-3">
                  {/* <button
                    onClick={() => onSelectAddOn && onSelectAddOn(a)}
                    className="inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2 bg-[#1A4699] text-white text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                  >
                    {a.cta}
                  </button> */}

                  <button
                    onClick={() =>
                      window.open(
                        "https://dashboard.konn3ct.com/addons",
                        "_blank"
                      )
                    }
                    className="inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2 bg-[#1A4699] text-white text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                  >
                    {a.cta}
                  </button>

                  {/* <button
                    onClick={() =>
                      navigator.clipboard &&
                      navigator.clipboard.writeText(
                        `${a.title} - ${a.priceUSD} / ${a.priceNGN}`
                      )
                    }
                    className="text-sm px-3 py-2 rounded-lg border border-gray-200 dark:border-slate-700 text-muted-foreground hover:bg-gray-50"
                  >
                    Copy
                  </button> */}
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>

      {/* Payment Methods */}
      {/* <div className="max-w-7xl mx-auto mt-12 text-center">
        <h3 className="text-lg font-bold mb-6 text-black">
          Most payment methods supported
        </h3>
        <div className="flex flex-wrap justify-center gap-6 opacity-80">
          <img
            src={Payment}
            alt="Support"
            className="w-1/3 h-16 bg-gray-200 rounded flex items-center justify-center text-xs font-semibold"
          />
        </div>
      </div> */}

      <div className="flex items-center justify-center gap-3 text-gray-800 text-lg font-semibold relative z-10 space-x-1 mt-14">
        <span className="inline-block h-10 w-6">
          <img src={LeafL} alt="Leaf Left" className="h-full object-contain" />
        </span>

        <p className="text-center">
          Trusted by 15,000+ Individuals and companies.
        </p>

        <span className="inline-block h-10 w-6">
          <img src={LeafR} alt="Leaf Right" className="h-full object-contain" />
        </span>
      </div>
    </div>
  );
};

export default Kpricing;
